/** The matching rule every Page uses: an exact path must equal the whole
 *  pathname, any other path matches as a prefix. */
export function routeMatches(
  pathname: string,
  path: string,
  exact: boolean | undefined,
): boolean {
  return exact ? pathname === path : pathname.startsWith(path);
}
